import React from "react";
import { useBranding } from "@/hooks/useBranding";

interface BrandingProviderProps {
  children: React.ReactNode;
}

export const BrandingProvider: React.FC<BrandingProviderProps> = ({ children }) => {
  useBranding();
  
  return <>{children}</>;
};
